module.exports = __webpack_public_path__ + "img/confirmed_id.9476f42c.png";